import React from 'react';

export const getUserOptions = (contacts: any) => contacts
  .map(({
    account
  }: any) => ({
    value: account.id,
    label: `${account.firstName} ${account.lastName} (${account.email})`
  }));
